import {initParam} from "../setting/initParam";
import {
    CalcPlaceFromDiagonalY, centeredLine, createDefaultMaterial,
    getMetaNumber,
    getOffsetsAfterRotation, InitialStruct,
    JoinPlane,
    JoinType,
    JoinVariant,
    Line2,
    matBeam, ParamsGetSimpleBoard, RenderElement,
    RenderStruct, simpleSize, Vec3
} from "@3dcalc/3dpClient";
import {api} from "../api/api";
import {SpecStructElement, StructData} from "@3dcalc/3dpClient/dist/types/renderElements";
import { locale } from "../setting/locale";


export async function getPK(s:InitialStruct, sBoard:simpleSize, modeBuild: boolean = false): Promise<StructData> {
    const lang = new URLSearchParams(window.location.search).get('lang') as 'en'|'de'|'ru' || 'en';

    const H = initParam.elementData.f2.sizeBoard.l - initParam.gash.simple - initParam.gash.simple
    const angle =  45 //* Math.PI / 180
    const angleR =  45 * Math.PI / 180


    const placeInfo = CalcPlaceFromDiagonalY(s.a, H)

    initParam.elementData.f3.sizeBoard.l = placeInfo.l

    const paramsGetSimpleBoard: ParamsGetSimpleBoard = {
        modeBuild: modeBuild,
        shift: {back: 0, front: 0},
        sizeBoard: {w: sBoard.w, h: sBoard.h, l: 0.781},
        cuts: [],
        joinEnd: {
            joinType: JoinType.End,
            joinPlane: JoinPlane.Top,
            indent: 0,
            angle:  90-angle,
            variant: JoinVariant.Angle
        },
        joinStart: {
            joinType: JoinType.Start,
            joinPlane: JoinPlane.Top,
            indent: 0,
            angle:  angle,
            variant: JoinVariant.Angle,
        },
    }
    const paramsGetSimpleBoard2: ParamsGetSimpleBoard = {
        modeBuild: modeBuild,
        shift: {back: 0, front: 0},
        sizeBoard: {w: sBoard.w, h: sBoard.h, l: 0.781},
        cuts: [],
        joinEnd: {
            joinType: JoinType.End,
            joinPlane: JoinPlane.Right,
            indent: 0,
            angle:  90-angle,
            variant: JoinVariant.Angle
        },
        joinStart: {
            joinType: JoinType.Start,
            joinPlane: JoinPlane.Right,
            indent: 0,
            angle:  angle,
            variant: JoinVariant.Angle,
        },
    }
    const rs:RenderStruct = {
        vertices: [],
        indices: [],
        uvs: [],
        material: [],
        elements: [],
        group: ''
    }
    const spec: SpecStructElement[] = []
    rs.material.push(createDefaultMaterial())
    const resultGetSimpleBoard = await api.getSimpleBoard.build(paramsGetSimpleBoard)
    const resultGetSimpleBoard2 = await api.getSimpleBoard.build(paramsGetSimpleBoard2)
    rs.uvs.push(resultGetSimpleBoard.mesh.uvs)
    const numUvs = rs.uvs.length - 1
    rs.uvs.push(resultGetSimpleBoard2.mesh.uvs)
    const numUvs2 = rs.uvs.length - 1
    rs.indices.push(resultGetSimpleBoard.mesh.indices)
    const numIndices = rs.indices.length - 1
    rs.indices.push(resultGetSimpleBoard2.mesh.indices)
    const numIndices2 = rs.indices.length - 1
    rs.vertices.push(resultGetSimpleBoard.mesh.vertices)
    const numVertices = rs.vertices.length - 1
    rs.vertices.push(resultGetSimpleBoard2.mesh.vertices)
    const numVertices2 = rs.vertices.length - 1
    const nameGroup = 'PK'
    rs.group = nameGroup
    const numGroups = rs.group.length
    const meta = resultGetSimpleBoard.meta

    const realSeg = centeredLine(initParam.maps.f1.lineCut, s.l)

    const metaJEOffsetEnd = getMetaNumber(meta.modify, "joinEnd", "offset")
    const metaJEOffsetStart = getMetaNumber(meta.modify, "joinStart", "offset")

    const metaF3WidthEnd = getMetaNumber(meta.modify, "joinEnd", "width")
    const metaF3WidthStart = getMetaNumber(meta.modify, "joinStart", "width")

    const line1:Line2 = [[meta.h / 2, 0],[meta.h / 2, meta.l]]
    const line2:Line2 = [[-meta.h / 2, 0 + metaJEOffsetStart], [-meta.h / 2, meta.l - metaJEOffsetEnd]]

    const p:Line2[] = [line1, line2]

    const testOfset = getOffsetsAfterRotation(p, -Math.PI / 2 + angleR)
    let countPK = 0

    for (let i = 0; i < realSeg.length; i++) {
        const x = realSeg[i][0]

        const z = 0
            + s.h
            - initParam.gash.simple
            - meta.l / 2
            + testOfset.deltaTop

        const yR = 0
            + s.w / 2
            - initParam.elementData.pillar.sizeBoard.w
            - initParam.elementData.pk.sizeBoard.w / 2
            - testOfset.deltaLeft

        const yL = 0
            - s.w / 2
            + initParam.elementData.pillar.sizeBoard.w
            + initParam.elementData.pk.sizeBoard.w / 2
            + testOfset.deltaLeft

        const posR:Vec3 = [x, z, yR]
        const posL:Vec3 = [x, z, yL]

        const boardR: RenderElement = {
            indices: numIndices,
            name: `${nameGroup} - ${i}`,
            nameGroup: nameGroup,
            position: posR,
            // rotation: [Math.PI / 2, 0, 0],
            rotation: [-Math.PI / 2 + angleR, 0, 0],
            uvs: numUvs,
            vertices: numVertices,
            material: 0,
        }
        rs.elements.push(boardR)
        countPK++

        const boardL: RenderElement = {
            indices: numIndices,
            name: `${nameGroup} - ${i}`,
            nameGroup: nameGroup,
            position: posL,
            rotation: [-Math.PI / 2 - angleR, 0, 0],
            uvs: numUvs,
            vertices: numVertices,
            material: 0,
        }
        rs.elements.push(boardL)
        countPK++


        {
            const xFront = realSeg[i][0]
                + initParam.elementData.pillar.sizeBoard.w / 2
                + testOfset.deltaLeft
                + initParam.elementData.pk.sizeBoard.w / 2

            const xBack = realSeg[i][0]
                - initParam.elementData.pillar.sizeBoard.w / 2
                - testOfset.deltaLeft
                - initParam.elementData.pk.sizeBoard.w / 2

            const yR = 0
                + s.w / 2
                - initParam.elementData.pk.sizeBoard.w / 2

            const yL = 0
                - s.w / 2
                + initParam.elementData.pk.sizeBoard.w / 2

            const offsetF1 = -initParam.elementData.f1.sizeBoard.w / 2 + initParam.elementData.pillar.sizeBoard.w / 2

            if (i !== 0) {
                const boardR: RenderElement = {
                    indices: numIndices2,
                    name: `${nameGroup} - ${i}`,
                    nameGroup: nameGroup,
                    position: [i === realSeg.length - 1 ? xFront + offsetF1:xFront, z, yR],
                    rotation: [0, 0, Math.PI-angleR],
                    uvs: numUvs2,
                    vertices: numVertices2,
                    material: 0,
                }
                rs.elements.push(boardR)
                countPK++
                {
                    const boardR: RenderElement = {
                        indices: numIndices2,
                        name: `${nameGroup} - ${i}`,
                        nameGroup: nameGroup,
                        position: [i === realSeg.length - 1 ? xFront + offsetF1:xFront, z, yL],
                        rotation: [0, 0, Math.PI-angleR],
                        uvs: numUvs2,
                        vertices: numVertices2,
                        material: 0,
                    }
                    rs.elements.push(boardR)
                    countPK++
                }
            }
            if (i !== realSeg.length - 1) {
                const boardR: RenderElement = {
                    indices: numIndices2,
                    name: `${nameGroup} - ${i}`,
                    nameGroup: nameGroup,
                    position: [i === 0 ? xBack - offsetF1:xBack, z, yL],
                    rotation: [0, 0, +angleR],
                    uvs: numUvs2,
                    vertices: numVertices2,
                    material: 0,
                }
                rs.elements.push(boardR)
                countPK++
                {
                    const boardR: RenderElement = {
                        indices: numIndices2,
                        name: `${nameGroup} - ${i}`,
                        nameGroup: nameGroup,
                        position: [i === 0 ? xBack - offsetF1:xBack, z, yR],
                        rotation: [0, 0, +angleR],
                        uvs: numUvs2,
                        vertices: numVertices2,
                        material: 0,
                    }
                    rs.elements.push(boardR)
                    countPK++
                }
            }
        }


    }
    spec.push({
        w: resultGetSimpleBoard.meta.w,
        h: resultGetSimpleBoard.meta.h,
        l: resultGetSimpleBoard.meta.l,
        name: locale['decorative_braces'][lang],
        group: locale['decorative_braces'][lang],
        count: countPK,
    })

    return {rs: rs, spec: spec}
}
